import PropTypes from 'prop-types';
import React from 'react';
import { withPlayer } from './PlayerContext';
import ViralVideoControls from './controls/ViralVideoControls';
import Time from './controls/Time';
import Volume from '../components/controls/Volume';
import s from './style/Overlay';

const ViralOverlayComponent = ({
  clip,
  isTrivia,
  isVisible,
  showVideoControls,
  toggleCaption,
  captionIndex,
  onCCSettingsChange,
  resetCCSettings,
  haveCaptions,
  isMuted,
  player,
  isStopped,
  showReset,
  playerIsFullscreen,
  exitFullscreen,
  enterFullscreen,
  onCCMenuOpen,
  onCCSubmenuOpen,
  onCCSetIndex,
  isCCMenuOpen,
  currentCCMenu,
  currentCCMenuName,
  ccMenuSelectedIndexes,
  ccMenuClose,
  isCCEnabled,
  internalFullscreen,
  isFullscreenDisabled,
}) => {
  const getElapsed = (start) => Date.now() - new Date(start).getTime();
  const elapsed = getElapsed(clip.duration);

  return (
    <s.wrapper>
      <s.volumeWrapper
        isStopped={isStopped}
        visible={isVisible}
        isMuted={isMuted}
        playerIsFullscreen={playerIsFullscreen}
      >
        <Volume
          isMuted={isMuted}
          volume={player.volume}
          mute={player.mute}
          unMute={player.unMute}
          setVolume={player.setVolume}
          playerIsFullscreen={playerIsFullscreen}
        />
      </s.volumeWrapper>
      <s.videoControllsWrapper playerIsFullscreen={playerIsFullscreen} visible={isVisible}>
        {!player.autoPlayBlocked && playerIsFullscreen && (
          <s.copyWrapper playerIsFullscreen={playerIsFullscreen}>
            <s.content>
              <s.title>{clip.name}</s.title>
            </s.content>
          </s.copyWrapper>
        )}

        {!playerIsFullscreen && (
          <s.copyWrapperMinimized>
            <Time
              playerIsFullscreen={playerIsFullscreen}
              duration={clip.duration}
              position={elapsed}
            />
          </s.copyWrapperMinimized>
        )}

        <s.gradient playerIsFullscreen={playerIsFullscreen} />

        <ViralVideoControls
          player={player}
          nowPlaying={{ title: clip.name, name: clip.name }}
          hideTimes
          isMuted={isMuted}
          isTrivia={isTrivia}
          haveCaptions={haveCaptions}
          playerIsFullscreen={playerIsFullscreen}
          showVideoControls={showVideoControls}
          toggleCaption={toggleCaption}
          onCCSettingsChange={onCCSettingsChange}
          captionIndex={captionIndex}
          resetCCSettings={resetCCSettings}
          showReset={showReset}
          exitFullscreen={exitFullscreen}
          enterFullscreen={enterFullscreen}
          duration={clip.duration}
          elapsed={elapsed}
          onCCMenuOpen={onCCMenuOpen}
          onCCMenuClose={ccMenuClose}
          onCCSubmenuOpen={onCCSubmenuOpen}
          onCCSetIndex={onCCSetIndex}
          isCCMenuOpen={isCCMenuOpen}
          currentCCMenu={currentCCMenu}
          currentCCMenuName={currentCCMenuName}
          ccMenuSelectedIndexes={ccMenuSelectedIndexes}
          isCCEnabled={isCCEnabled}
          internalFullscreen={internalFullscreen}
          isFullscreenDisabled={isFullscreenDisabled}
        />
      </s.videoControllsWrapper>
    </s.wrapper>
  );
};

ViralOverlayComponent.propTypes = {
  clip: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    duration: PropTypes.number.isRequired,
  }).isRequired,
  isTrivia: PropTypes.bool.isRequired,
  isStopped: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired,
  playerIsFullscreen: PropTypes.bool.isRequired,
  onCCMenuOpen: PropTypes.func.isRequired,
  onCCMenuClose: PropTypes.func.isRequired,
  onCCSubmenuOpen: PropTypes.func.isRequired,
  onCCSetIndex: PropTypes.func.isRequired,
  isCCMenuOpen: PropTypes.bool.isRequired,
  currentCCMenu: PropTypes.instanceOf(Array).isRequired,
  currentCCMenuName: PropTypes.string.isRequired,
  ccMenuSelectedIndexes: PropTypes.instanceOf(Array).isRequired,
  showVideoControls: PropTypes.bool.isRequired,
  toggleCaption: PropTypes.func.isRequired,
  captionIndex: PropTypes.number.isRequired,
  onCCSettingsChange: PropTypes.func.isRequired,
  exitFullscreen: PropTypes.func.isRequired,
  enterFullscreen: PropTypes.func.isRequired,
  resetCCSettings: PropTypes.func.isRequired,
  ccMenuClose: PropTypes.func.isRequired,
  haveCaptions: PropTypes.bool.isRequired,
  isMuted: PropTypes.bool.isRequired,
  showReset: PropTypes.bool.isRequired,
  isCCEnabled: PropTypes.bool.isRequired,
  internalFullscreen: PropTypes.bool.isRequired,
  isFullscreenDisabled: PropTypes.bool.isRequired,
};

export const ViralOverlay = withPlayer(ViralOverlayComponent);
